
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/league/detail",
      function () {
        return require("private-next-pages/league/detail/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/league/detail"])
      });
    }
  